import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {ConsolidatedBillingOrderStatusType} from "../../types/consolidated-billing-order-status.type";
import {ConsolidatedBillingOrderService} from "../../services/consolidated-billing-order.service";
import {SapDocumentType} from "../../types/sap-document.type";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";

export class ConsolidatedBillingOrdersTableRowCtrl implements IController {

  billingOrder: any;
  isSelected: boolean;
  onSelect: Function;
  onToggle: Function;
  onEdit: Function;
  onAddBillingOrders: Function;
  onCreateRefund: Function;
  resetPayManually: Function;

  public consolidatedBillingOrderStatusType: typeof ConsolidatedBillingOrderStatusType = ConsolidatedBillingOrderStatusType;
  public canCreateInvoice: boolean;
  public totalRefundAmount: number;

  constructor(private consolidatedBillingOrderService: ConsolidatedBillingOrderService,
              private $scope: IScope, private $consolidatedBillingOrders, private billingAccountDialogService: BillingAccountDialogService) {
  }

  $onInit() {
    if (this.billingOrder) {
      this._setBillingOrderInfo(this.billingOrder);

      const billingOrderRef = this.$consolidatedBillingOrders(this.billingOrder.id);

      billingOrderRef.$bindCtrl(this.$scope, this, 'billingOrder');
      billingOrderRef.$registerOnUpdateHandler(this, (billingOrder) => {
        this._setBillingOrderInfo(billingOrder);
      })
    }
  }

  $onChanges(changes) {
    if (changes.billingOrder && !changes.billingOrder.isFirstChange()) {
      this.$onInit();
    }
  }

  onCreateInvoice() {
    this.billingAccountDialogService.selectSapDocumentType()
      .then((sapDocumentType: SapDocumentType) => {
        this.consolidatedBillingOrderService.createInvoice(this.billingOrder.id, sapDocumentType);
      })
  }

  private _setBillingOrderInfo(billingOrder) {
    this.canCreateInvoice = (billingOrder.totalPrice > 0) && !_.filter(billingOrder.billingOrderReferences || [], (c) => {
      return c.status !== this.consolidatedBillingOrderStatusType.Delivered;
    }).length


    // this.canCreateInvoice = billingOrder.status === 'Open' ?
    //   !_.filter(billingOrder.billingOrderReferences || [], (c) => {
    //     return c.status !== this.consolidatedBillingOrderStatusType.Delivered;
    //   }).length : false;

    this.totalRefundAmount = _.reduce(billingOrder.refundInfos, (sum: any, refundData) => {
      return sum + (refundData?.refundAmount || 0);
    }, 0);
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrdersTableRow', {
    require: {
      consolidatedBillingOrdersTableCtrl: '^consolidatedBillingOrdersTable'
    },
    bindings: {
      billingOrder: '<',
      isSelected: '<?',
      onSelect: '&',
      onToggle: '&',
      onEdit: '&',
      onAddBillingOrders: '&',
      onCreateRefund: '&',
      resetPayManually: '&'
    },
    template: require('./consolidated-billing-orders-table-row.html').default,
    controller: ConsolidatedBillingOrdersTableRowCtrl
  });
